import { SubspaceStore, ItemStore } from "../ELYXStore";

const SubspaceUtilities = {
  getSubspaceID(itemID = "") {
    let subspaceID = "";
    if (SubspaceStore.state.subspace && SubspaceStore.state.subspace._id) {
      /** If a Space is active and selected, use that */
      subspaceID = SubspaceStore.state.subspace._id;
    } else if (itemID) {
      /** If no active Space selected, such as when inside a Search Result which has no particular
       * context, then attempt to extract SpaceID from item the tag is being added to. */
      const existingItem = ItemStore.state.items.find((item) => item._id === itemID);
      if (existingItem && existingItem.contexts && existingItem.contexts.length) {
        const subspaceIDsArray = existingItem.contexts.map((obj) => obj._id);
        subspaceID = subspaceIDsArray; /** Return array instead */
      }
    }
    return subspaceID;
  },
};

export default SubspaceUtilities;
